/** Wochenrechnung der Einsatz-Plantafel (lokale Kalendertage, Montag = Wochenbeginn). */

const TAG_MS = 24 * 60 * 60 * 1000;

/** Montag 00:00 (lokal) der Woche, die `offsetWochen` Wochen von der Woche von `heute` entfernt ist. */
export function montagDerWoche(offsetWochen: number, heute: Date = new Date()): Date {
  const tag = (heute.getDay() + 6) % 7; // Mo=0
  const montag = new Date(heute);
  montag.setDate(heute.getDate() - tag + offsetWochen * 7);
  montag.setHours(0, 0, 0, 0);
  return montag;
}

/** Wochen-Offset (0 = Woche von `heute`) der Woche, in der der Kalendertag `tag` (yyyy-mm-dd)
    liegt - für den Sprung aus der Kundenakte in die passende Plantafel-Woche.
    null bei ungültigem Datum. */
export function wochenOffsetFuerTag(tag: string, heute: Date = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(tag);
  if (!m) return null;
  const [jahr, monat, tagImMonat] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const datum = new Date(jahr, monat - 1, tagImMonat);
  // Überlauf (31.02.) rollt in JS in den Folgemonat - das ist kein gültiger Tag.
  if (datum.getMonth() !== monat - 1 || datum.getDate() !== tagImMonat) return null;
  const diffTage = Math.round((montagDerWoche(0, datum).getTime() - montagDerWoche(0, heute).getTime()) / TAG_MS);
  return Math.round(diffTage / 7);
}
